"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _togaButton = require("@thinkific/toga-button");

var _togaIcon = _interopRequireDefault(require("@thinkific/toga-icon"));

var _togaTheme = _interopRequireDefault(require("@thinkific/toga-theme"));

var _inlineAlertCSS = _interopRequireDefault(require("./inlineAlertCSS"));

var _InlineAlert = _interopRequireDefault(require("./InlineAlert.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  && {\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var cx = _bind["default"].bind(_InlineAlert["default"]);

var StyledAlert = _styledComponents["default"].div(_templateObject(), _inlineAlertCSS["default"]);

var InlineAlert = function InlineAlert(props) {
  var className = props.className,
      type = props.type,
      hasCloseButton = props.hasCloseButton,
      children = props.children,
      onClose = props.onClose;
  var theme = (0, _react.useContext)(_togaTheme["default"]);
  var icon;

  switch (type) {
    case 'success':
      icon = 'circle-fill-check';
      break;

    case 'danger':
      icon = 'stop-sign';
      break;

    case 'warning':
      icon = 'warning';
      break;

    case 'info':
    default:
      icon = 'circle-fill-info';
  }

  return /*#__PURE__*/_react["default"].createElement(StyledAlert, {
    className: cx('inline__alert', "inline__alert--".concat(type), className),
    theme: theme,
    type: type
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: cx('inline__alert-text__wrapper')
  }, /*#__PURE__*/_react["default"].createElement(_togaIcon["default"], {
    name: icon
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: cx('inline__alert-text')
  }, children)), hasCloseButton && /*#__PURE__*/_react["default"].createElement(_togaButton.IconButton, {
    appearance: "utility",
    className: cx('inline__alert-close-button'),
    name: "x-dismiss",
    title: "Close notification",
    onClick: onClose
  }));
};

InlineAlert.propTypes = {
  /** alert content */
  children: _propTypes["default"].node.isRequired,

  /** Optional classnames (array or string) */
  className: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].string]),

  /** shows/hides the alert close button */
  hasCloseButton: _propTypes["default"].bool,

  /** Type of inline alert */
  type: _propTypes["default"].oneOf(['success', 'danger', 'warning', 'info']),

  /** callback function after close button is clicked */
  onClose: _propTypes["default"].func
};
InlineAlert.defaultProps = {
  className: null,
  type: 'info',
  hasCloseButton: false,
  onClose: function onClose() {}
};
var _default = InlineAlert;
exports["default"] = _default;